/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { EntityDocumentsTab } from '@/app/(client)/my-styles/-components/EntityDocumentsTab';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { styleDocumentsQueryOptions } from '@/app/(client)/my-styles/-hooks/useStyleDocumentsQuery';
import { styleOrderDocumentsQueryOptions } from '@/app/(client)/my-styles/-hooks/useStyleOrderDocumentsQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents',
)({
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData(
        styleOrderDocumentsQueryOptions(params.id, { page: 1, count: 20 }),
      ),
      queryClient.ensureQueryData(
        styleDocumentsQueryOptions(params.id, { page: 1, count: 20 }),
      ),
    ]),
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { kind, id } = Route.useParams();
  const safeKind = isEntityKindPath(kind) ? kind : 'styles';
  return <EntityDocumentsTab kind={safeKind} entityId={id} />;
}
